export default function getEnv () {
  // 
  const domain = window?.location?.hostname;
  if (domain === 'test-platform.ads.ahaglobal.io' || domain === 'test.brand.ahacreator.com' || domain === 'localhost') {
    return 'development';
  }
  if (domain === 'brand.ahacreator.com') {
    return 'production';
  }
  return 'production';
}